import type { UploadFile } from "antd"

import type { Attachment } from "../../../Album/types/attachment.types.ts"

const mapAttachmentToUploadFile = (attachment: Attachment): UploadFile => ({
  uid: attachment.id,
  name: attachment.original_filename,
  status: "done",
  url: attachment.file,
  size: attachment.file_size,
  type: attachment.mime_type,
  response: attachment
})

const mapAttachmentsToFileList = (attachments: Attachment[]): UploadFile[] => {
  return attachments.map(mapAttachmentToUploadFile)
}

export { mapAttachmentsToFileList, mapAttachmentToUploadFile }
